import React from 'react';

const NamesScreen = ({
  names,
  nameInput,
  onNameInput,
  onAddName,
  onRemoveName,
  onStart,
}) => {
  const canStart = names.length >= 2;

  return (
    <div
      style={{
        minHeight: '100svh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 'clamp(24px, 6vw, 60px)',
        gap: 18,
      }}
    >
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.28em',
          color: 'var(--c-warm-700)',
          animation: 'ibgFadeUp 0.6s ease both',
        }}
      >
        TONIGHT'S CIRCLE
      </div>
      <h1
        style={{
          margin: 0,
          fontFamily: 'var(--f-heading)',
          fontWeight: 400,
          fontSize: 'clamp(34px, 6.5vw, 52px)',
          lineHeight: 1.08,
          animation: 'ibgFadeUp 0.6s 0.08s ease both',
        }}
      >
        Who's joining?
      </h1>
      <p
        style={{
          margin: 0,
          fontSize: 16,
          color: 'var(--c-n-700)',
          animation: 'ibgFadeUp 0.6s 0.14s ease both',
        }}
      >
        Add everyone at the table — nicknames are perfect.
      </p>
      <div
        style={{
          display: 'flex',
          gap: 10,
          width: 'min(420px, 90vw)',
          marginTop: 8,
          animation: 'ibgFadeUp 0.6s 0.2s ease both',
        }}
      >
        <input
          value={nameInput}
          onChange={(e) => onNameInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onAddName();
          }}
          placeholder='Type a name, press Enter'
          className='ibg-input'
          style={{ flex: 1, minWidth: 0 }}
        />
        <button
          type='button'
          onClick={onAddName}
          className='ibg-btn-warm'
          style={{ fontSize: 15, padding: '0 24px' }}
        >
          Add
        </button>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 10,
          maxWidth: 560,
          minHeight: 44,
          padding: '6px 0',
        }}
      >
        {names.map((n, i) => (
          <div
            key={n}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              background: 'var(--c-warm-200)',
              borderRadius: 999,
              padding: '8px 8px 8px 18px',
              fontSize: 15,
              fontWeight: 600,
              color: 'var(--c-warm-800)',
              animation: 'ibgFadeUp 0.3s ease both',
            }}
          >
            {n}
            <button
              type='button'
              onClick={() => onRemoveName(i)}
              className='ibg-chip-x'
              aria-label={`Remove ${n}`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <button
        type='button'
        onClick={onStart}
        className='ibg-btn-primary'
        style={{
          fontSize: 15,
          padding: '16px 38px',
          opacity: canStart ? 1 : 0.4,
        }}
      >
        Start drawing
      </button>
      <div style={{ fontSize: 13, color: 'var(--c-n-600)' }}>
        {canStart
          ? `${names.length} joining tonight`
          : 'Add at least two people to begin.'}
      </div>
    </div>
  );
};

export default NamesScreen;
